<template>
  <template v-if="hasPlacePort">
    <p data-test="from-to-place">
      {{ formatLocation(place, false) }}
    </p>
    <p class="color-neutral-subtle" data-test="from-to-port">
      {{ typeLabel }}
      {{ formatLocation(port) }}
    </p>
    <p v-if="port?.[type]?.dateTime">
      <template v-if="port?.[type]?.timeQualifier === 'ESTIMATED'">
        {{ dayjs(port[type].dateTime).format("DD MMM") }} ({{
          type === "departure" ? $t("common.etd") : $t("common.eta")
        }})
      </template>
      <template v-else>{{ dayjs(port[type].dateTime).format("DD MMM, HH:mm") }}</template>
    </p>
    <p v-else>-</p></template
  >
  <p v-else class="color-neutral-subtle not-available">
    {{ $t("common.notAvailable") }}
  </p>
</template>

<script>
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";

dayjs.extend(isSameOrAfter);

export default {
  props: {
    place: {
      type: Object,
      required: true
    },
    port: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: false,
      default: "departure"
    }
  },
  computed: {
    hasPlacePort() {
      return (this.place && Object.keys(this.place)?.length > 0) || (this.port && Object.keys(this.port)?.length > 0);
    },
    typeLabel() {
      return this.type === "departure" && dayjs(this.port?.[this.type]?.dateTime).isBefore(dayjs())
        ? this.$t("common.departed")
        : this.type === "departure" && dayjs(this.port?.[this.type]?.dateTime).isSameOrAfter(dayjs())
          ? this.$t("common.departing")
          : this.type === "arrival" && dayjs(this.port?.[this.type]?.dateTime).isBefore(dayjs())
            ? this.$t("common.arrived")
            : this.$t("common.arriving");
    }
  },
  methods: {
    dayjs,
    formatLocation(port, showCountry = true) {
      const parts = [];
      if (port?.cityName) {
        parts.push(port.cityName);
      }
      if (port?.countryName && showCountry) {
        parts.push(port.countryName);
      }
      if (port?.countryCode) {
        parts.push(port.countryCode);
      }
      return parts.length > 0 ? parts.join(", ") : "-";
    }
  }
};
</script>
